import { Button, Typography } from '@mui/material';
import { getWorkoutName } from '@strength/domain';
import { formatDate } from '@strength/utils';
import { WorkoutStatusBadge } from '../../../../components/badge/workout-status-badge';
import { getLocale } from '../../../../utils/i18n';
import { useTabletContext } from '../context/TabletContext';
import { AthleteWithTeam, WorkoutData } from '../types';

type WorkoutItemProps = {
  workout: WorkoutData;
  athlete: AthleteWithTeam;
};

export const WorkoutItem = ({ workout, athlete }: WorkoutItemProps) => {
  const { onSelectWorkout } = useTabletContext();

  const getWorkoutDisplayName = () => {
    const blockParams = {
      name: workout.block?.name || '',
      cycleLabel: workout.block?.cycleLabel || '',
      sessionLabel: workout.block?.sessionLabel || '',
    };
    return getWorkoutName(workout, blockParams);
  };

  const getSubText = () => {
    const blockName = workout.block?.name;
    const cycleLabel = workout.block?.cycleLabel;
    const cycleSortOrder = workout.cycleSortOrder;

    if (blockName) {
      return `${blockName}, ${cycleLabel} ${cycleSortOrder}`;
    }
    return '';
  };

  const workoutName = getWorkoutDisplayName();

  return (
    <Button
      variant="outlined"
      className="flex flex-col p-3 rounded-xl relative gap-1 justify-start shadow-none flex-shrink-0"
      onClick={() =>
        onSelectWorkout(workout.workoutId, workoutName, athlete.id)
      }
    >
      <div className="flex flex-row justify-between items-center w-full">
        {/* Main workout name */}
        <Typography variant="h4" className="font-medium block no-wrap truncate">
          {getWorkoutDisplayName()}
        </Typography>
        {/* Assigned Date in top right */}
        {workout.assignedDate && (
          <Typography
            variant="subtitle1"
            className="text-black/60 no-wrap truncate flex-shrink-0"
          >
            {formatDate(workout.assignedDate, getLocale(), {
              month: 'short',
              day: 'numeric',
            })}
          </Typography>
        )}
      </div>

      <div className="flex flex-row justify-between items-center w-full">
        {/* Block name and cycle info as subtext */}
        {getSubText() && (
          <Typography
            variant="subtitle1"
            className="text-black/60 w-full text-left no-wrap truncate"
          >
            {getSubText()}
          </Typography>
        )}
        <WorkoutStatusBadge status={{ type: workout.status }} />  
      </div>
    </Button>
  );
};
